import React, { useEffect, useState } from "react";
import styles from "./kyc.module.css";
import { ArrowDown2, Camera } from "iconsax-react";
import Lottie from "lottie-react";
import loader from "../../assets/lottie/loader.json";
import { browserName } from "react-device-detect";
import { useDispatch } from "react-redux";
import { verifyAddress } from "../../store/KYC/kycAction";


const AddressVerification = ({setOpenModal4}) => {
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false);
  const [state, setState] = useState("");
  const [country, setCountry] = useState("");
  const [street, setStreet] = useState("");
  const [city, setCity] = useState("");
  const [postalCode, setPostalCode] = useState("");
  const [disabled, setDisabled] = useState(true);
  const [openCountryType, setOpenCountryType] = useState(false);


  const countries = [
    { id: 1, title: "Nigeria", tag: "NGN" },
    { id: 2, title: "Ghana", tag: "GHS" },
  ]
    

  const toggleCountry = () => {
    setOpenCountryType((prev) => {
      if (prev === false) {
        return true;
      } else if (prev === true) {
        return false;
      }
    });
  };


  const handleCountry = (e) => {
    setOpenCountryType(false);
    setCountry(e.target.textContent);
  };


  const handleProceed = (e) => {
    e.preventDefault();
    setLoading(true)
    dispatch(verifyAddress({
      country,
      state,
      street: street,
      city,
      postal_code: postalCode
    })).then((res)=>{
      if(res?.type === "verifyAddress/fulfilled"){
        setLoading(false)
        setOpenModal4(false);
        setCountry("")
        setState("")
        setStreet("")
        setCity("")
        setPostalCode("")
      }
      else if(res?.type === "verifyAddress/rejected"){
        setLoading(false)
      }
    })
  }

    // HANDLE BANK CLOSE ON CLICK OUT
    useEffect(() => {
      let handler = (e) => {
        if (e.target.id !== "country") {
          setOpenCountryType(false);
        } else if (e.target.id === "country") {
          toggleCountry();
        }
        if (e.target.id === "countryDrop") {
          setOpenCountryType(true);
        }
      };
  
      document.addEventListener("mousedown", handler);
  
      return () => {
        document.removeEventListener("mousedown", handler);
      };
    }, []);



  useEffect(() => {
      if (
          country !== "" &&
          state !== "" &&
          street !== "" &&
          city !== "" &&
          postalCode !== ""
      ) {
          setDisabled(false)
      }else{setDisabled(true)}
  })
    
  return (
    <div className={styles.bvn}>
      <h2>Upgrade Account</h2>
      <p className={styles.subHead}>
        Upgrade your Astro account with more <br /> personal information
      </p>

      <form> 

        <div>    
        <label>Street</label>
        <input
          type="text"
          value={street}
          onChange={(e) => setStreet(e.target.value)}
          style={{ color: '#1a1a1a'}}
          placeholder="e.g No 4, Daniel street"
        />
           <p style={{
                  fontSize: 10,
            textAlign: "left",
             marginBottom: 0
        }}>Please ensure your address is well detailed and accurate </p>
        </div>


        <div style={{marginTop: '20px'}} className={styles.labelPut}>
            <label htmlFor="country">Country</label>
            <div className={styles.select}>
              <div
                className={styles.selectInput}
                style={{cursor: 'pointer'}}
              >
                <input
                  id="country"
                  name="country"
                  type="text"
                  value={country}
                  style={{ color: '#1a1a1a'}}
                  placeholder="Select country"
                />
                {loading === true ? (
                  <div className={styles.lottieWrapDrop}>
                    <Lottie
                      style={{
                        width: "70px",
                        height: "70px",
                        color: "#fff",
                        padding: "0px",
                        margin: "0px",
                      }}
                      animationData={loader}
                      loop={true}
                    />
                  </div>
                ) : (
                  <ArrowDown2
                    style={{
                      transform:
                      openCountryType === true
                          ? "translateY( -50%) rotate(-0deg)"
                          : "translateY( -50%) rotate(-90deg)",
                      pointerEvents: "none",
                    }}
                    className={styles.dropDown}
                    size="20"
                    color="#909090"
                  />
                )}
              </div>
       
               <div
                style={{
                  height: openCountryType === true ? "auto" : "0px",
                }}
                className={styles.option}
              >
                {countries?.map((item, index) => (
                  <p
                    key={item.id}
                    id="countryDrop"
                    onClick={(e) => {
                      handleCountry(e);
                    }}
                  style={{
                       borderBottom: `${index !== countries.length - 1 ? '1px #90909039 solid': ''}`
                      }}
                  >
                    {item.title}
                  </p>
                ))}
              </div>
              
            </div>
          </div>

          <div>    
        <label>State</label>
        <input
          type="text"
          value={state}
          onChange={(e) => setState(e.target.value)}
          placeholder="Enter your state"
          style={{ color: '#1a1a1a'}}
        />
        </div>  

         {/* Postal code */}
         <div style={{marginTop: '10px'}}>    
          <label>Postal Code</label>
          <input
            type="text"
            value={postalCode}
            onChange={(e) => setPostalCode(e.target.value)}
            placeholder="Enter your postal code"
            style={{ color: '#1a1a1a'}}
          />
        </div>

        {/* City */}
        <div style={{marginTop: '10px'}}>    
          <label>City</label>
          <input
            type="text"
            value={city}
            onChange={(e) => setCity(e.target.value)}
            placeholder="Enter your city"
            style={{ color: '#1a1a1a'}}
          />
        </div>


      
        {loading === true ? (
          <div style={{marginTop: '25px'}} className={styles.lottieWrap}>
            <Lottie
              style={{
                width: "70px",
                height: "70px",
                color: "#fff",
                padding: "0px",
                margin: "0px",
              }}
              animationData={loader}
              loop={true}
            />
          </div>
        ) : (
          <button
          style={{marginTop: '25px'}}
            onClick={handleProceed}
            disabled={disabled}
            className={styles.proceed}
          >
            Upgrade Now
          </button>
        )}
      </form>

    </div>
  );
};

export default AddressVerification;
